const books = (state = [], action) => {
    switch(action.type) {
        case 'books':
            return action.payload;
        default:
            return state;
    }
}

export default books;